/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DeviceAuthRouteImport } from './routes/device-auth'
import { Route as UseCasesRouteRouteImport } from './routes/use-cases/route'
import { Route as LegalRouteRouteImport } from './routes/legal/route'
import { Route as InfoRouteRouteImport } from './routes/info/route'
import { Route as FeaturesRouteRouteImport } from './routes/features/route'
import { Route as ConceptsRouteRouteImport } from './routes/concepts/route'
import { Route as ComparisonsRouteRouteImport } from './routes/comparisons/route'
import { Route as DashboardRouteRouteImport } from './routes/_dashboard/route'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UseCasesIndexRouteImport } from './routes/use-cases/index'
import { Route as LegalIndexRouteImport } from './routes/legal/index'
import { Route as FeaturesIndexRouteImport } from './routes/features/index'
import { Route as ConceptsIndexRouteImport } from './routes/concepts/index'
import { Route as ComparisonsIndexRouteImport } from './routes/comparisons/index'
import { Route as UseCasesFinopsRouteImport } from './routes/use-cases/finops'
import { Route as UseCasesEnterpriseSecurityRouteImport } from './routes/use-cases/enterprise-security'
import { Route as UseCasesDataSynchronizationRouteImport } from './routes/use-cases/data-synchronization'
import { Route as UseCasesApiManagementRouteImport } from './routes/use-cases/api-management'
import { Route as UseCasesAiAutomationRouteImport } from './routes/use-cases/ai-automation'
import { Route as LegalTermsRouteImport } from './routes/legal/terms'
import { Route as LegalSecurityRouteImport } from './routes/legal/security'
import { Route as LegalPrivacyRouteImport } from './routes/legal/privacy'
import { Route as LegalComplianceRouteImport } from './routes/legal/compliance'
import { Route as InfoPricingRouteImport } from './routes/info/pricing'
import { Route as InfoContactRouteImport } from './routes/info/contact'
import { Route as InfoCareersRouteImport } from './routes/info/careers'
import { Route as InfoAboutRouteImport } from './routes/info/about'
import { Route as FeaturesWorkflowEngineRouteImport } from './routes/features/workflow-engine'
import { Route as FeaturesSsoSamlRouteImport } from './routes/features/sso-saml'
import { Route as FeaturesSecurityRouteImport } from './routes/features/security'
import { Route as FeaturesIntegrationsRouteImport } from './routes/features/integrations'
import { Route as FeaturesAnalyticsRouteImport } from './routes/features/analytics'
import { Route as FeaturesAiGatewayRouteImport } from './routes/features/ai-gateway'
import { Route as FeaturesAgentsPlatformRouteImport } from './routes/features/agents-platform'
import { Route as ConceptsZeroTrustSecurityRouteImport } from './routes/concepts/zero-trust-security'
import { Route as ConceptsWorkflowAutomationRouteImport } from './routes/concepts/workflow-automation'
import { Route as ConceptsWebhooksRouteImport } from './routes/concepts/webhooks'
import { Route as ConceptsRbacAbacRouteImport } from './routes/concepts/rbac-abac'
import { Route as ConceptsDataIntegrationRouteImport } from './routes/concepts/data-integration'
import { Route as ConceptsApiManagementRouteImport } from './routes/concepts/api-management'
import { Route as ConceptsApiGatewayRouteImport } from './routes/concepts/api-gateway'
import { Route as ConceptsAiAgentsRouteImport } from './routes/concepts/ai-agents'
import { Route as ComparisonsLangfuseRouteImport } from './routes/comparisons/langfuse'
import { Route as ComparisonsLangchainRouteImport } from './routes/comparisons/langchain'
import { Route as ComparisonsKongRouteImport } from './routes/comparisons/kong'
import { Route as ComparisonsAwsApiGatewayRouteImport } from './routes/comparisons/aws-api-gateway'
import { Route as ComparisonsApigeeRouteImport } from './routes/comparisons/apigee'
import { Route as DashboardSettingsRouteImport } from './routes/_dashboard/settings'
import { Route as DashboardProfileRouteImport } from './routes/_dashboard/profile'
import { Route as DashboardOverviewRouteImport } from './routes/_dashboard/overview'
import { Route as DashboardApiKeysRouteImport } from './routes/_dashboard/api-keys'
import { Route as DashboardAnalyticsRouteImport } from './routes/_dashboard/analytics'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthCallbackRouteImport } from './routes/_auth/callback'
import { Route as DashboardAdminRouteRouteImport } from './routes/_dashboard/admin/route'
import { Route as DashboardToolsIndexRouteImport } from './routes/_dashboard/tools/index'
import { Route as DashboardMarketplaceIndexRouteImport } from './routes/_dashboard/marketplace/index'
import { Route as DashboardIntegrationsIndexRouteImport } from './routes/_dashboard/integrations/index'
import { Route as DashboardEnvironmentsIndexRouteImport } from './routes/_dashboard/environments/index'
import { Route as DashboardDocsIndexRouteImport } from './routes/_dashboard/docs/index'
import { Route as DashboardDataIndexRouteImport } from './routes/_dashboard/data/index'
import { Route as DashboardCrewsIndexRouteImport } from './routes/_dashboard/crews/index'
import { Route as DashboardConnectorsIndexRouteImport } from './routes/_dashboard/connectors/index'
import { Route as DashboardAgentsIndexRouteImport } from './routes/_dashboard/agents/index'
import { Route as DashboardAdminIndexRouteImport } from './routes/_dashboard/admin/index'
import { Route as DashboardToolsBuilderRouteImport } from './routes/_dashboard/tools/builder'
import { Route as DashboardToolsIdRouteImport } from './routes/_dashboard/tools/$id'
import { Route as DashboardMarketplaceMyInstallsRouteImport } from './routes/_dashboard/marketplace/my-installs'
import { Route as DashboardMarketplaceSlugRouteImport } from './routes/_dashboard/marketplace/$slug'
import { Route as DashboardIntegrationsCallbackRouteImport } from './routes/_dashboard/integrations/callback'
import { Route as DashboardIntegrationsAddRouteImport } from './routes/_dashboard/integrations/add'
import { Route as DashboardIntegrationsProviderRouteImport } from './routes/_dashboard/integrations/$provider'
import { Route as DashboardEnvironmentsIdRouteImport } from './routes/_dashboard/environments/$id'
import { Route as DashboardDocsSplatRouteImport } from './routes/_dashboard/docs/$'
import { Route as DashboardDataAliasRouteImport } from './routes/_dashboard/data/$alias'
import { Route as DashboardDataSplatRouteImport } from './routes/_dashboard/data/$'
import { Route as DashboardCrewsCreateRouteImport } from './routes/_dashboard/crews/create'
import { Route as DashboardConnectorsNewRouteImport } from './routes/_dashboard/connectors/new'
import { Route as DashboardConnectorsConnectorIdRouteImport } from './routes/_dashboard/connectors/$connectorId'
import { Route as DashboardAdminAuditRouteImport } from './routes/_dashboard/admin/audit'
import { Route as DashboardAgentsCreateRouteRouteImport } from './routes/_dashboard/agents/create/route'
import { Route as DashboardAgentsCreateIndexRouteImport } from './routes/_dashboard/agents/create/index'
import { Route as DashboardAgentsIdIndexRouteImport } from './routes/_dashboard/agents/$id/index'
import { Route as DashboardAdminSuperadminIndexRouteImport } from './routes/_dashboard/admin/superadmin/index'
import { Route as DashboardAdminOrgIndexRouteImport } from './routes/_dashboard/admin/org/index'
import { Route as DashboardAgentsCreateJsonRouteImport } from './routes/_dashboard/agents/create/json'
import { Route as DashboardAgentsCreateFormRouteImport } from './routes/_dashboard/agents/create/form'
import { Route as DashboardAgentsCreateCanvasRouteImport } from './routes/_dashboard/agents/create/canvas'
import { Route as DashboardAgentsCreateAiRouteImport } from './routes/_dashboard/agents/create/ai'
import { Route as DashboardAgentsIdChatRouteImport } from './routes/_dashboard/agents/$id/chat'
import { Route as DashboardAdminSuperadminUsersRouteImport } from './routes/_dashboard/admin/superadmin/users'
import { Route as DashboardAdminSuperadminSystemRouteImport } from './routes/_dashboard/admin/superadmin/system'
import { Route as DashboardAdminSuperadminOrganizationsRouteImport } from './routes/_dashboard/admin/superadmin/organizations'
import { Route as DashboardAdminOrgUsersRouteImport } from './routes/_dashboard/admin/org/users'
import { Route as DashboardAdminOrgSsoRouteImport } from './routes/_dashboard/admin/org/sso'
import { Route as DashboardAdminOrgSecurityRouteImport } from './routes/_dashboard/admin/org/security'
import { Route as DashboardAdminOrgSdkKeysRouteImport } from './routes/_dashboard/admin/org/sdk-keys'
import { Route as DashboardAdminOrgScimRouteImport } from './routes/_dashboard/admin/org/scim'
import { Route as DashboardAdminOrgRolesRouteImport } from './routes/_dashboard/admin/org/roles'
import { Route as DashboardAdminOrgPoliciesRouteImport } from './routes/_dashboard/admin/org/policies'
import { Route as DashboardAdminOrgApiKeysRouteImport } from './routes/_dashboard/admin/org/api-keys'
import { Route as DashboardAdminDataRedisRouteImport } from './routes/_dashboard/admin/data/redis'
import { Route as DashboardAdminDataPostgresRouteImport } from './routes/_dashboard/admin/data/postgres'
import { Route as DashboardAdminDataClickhouseRouteImport } from './routes/_dashboard/admin/data/clickhouse'

const DeviceAuthRoute = DeviceAuthRouteImport.update({
  id: '/device-auth',
  path: '/device-auth',
  getParentRoute: () => rootRouteImport,
} as any)
const UseCasesRouteRoute = UseCasesRouteRouteImport.update({
  id: '/use-cases',
  path: '/use-cases',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalRouteRoute = LegalRouteRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const InfoRouteRoute = InfoRouteRouteImport.update({
  id: '/info',
  path: '/info',
  getParentRoute: () => rootRouteImport,
} as any)
const FeaturesRouteRoute = FeaturesRouteRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => rootRouteImport,
} as any)
const ConceptsRouteRoute = ConceptsRouteRouteImport.update({
  id: '/concepts',
  path: '/concepts',
  getParentRoute: () => rootRouteImport,
} as any)
const ComparisonsRouteRoute = ComparisonsRouteRouteImport.update({
  id: '/comparisons',
  path: '/comparisons',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UseCasesIndexRoute = UseCasesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UseCasesRouteRoute,
} as any)
const LegalIndexRoute = LegalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LegalRouteRoute,
} as any)
const FeaturesIndexRoute = FeaturesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FeaturesRouteRoute,
} as any)
const ConceptsIndexRoute = ConceptsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConceptsRouteRoute,
} as any)
const ComparisonsIndexRoute = ComparisonsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ComparisonsRouteRoute,
} as any)
const UseCasesFinopsRoute = UseCasesFinopsRouteImport.update({
  id: '/finops',
  path: '/finops',
  getParentRoute: () => UseCasesRouteRoute,
} as any)
const UseCasesEnterpriseSecurityRoute =
  UseCasesEnterpriseSecurityRouteImport.update({
    id: '/enterprise-security',
    path: '/enterprise-security',
    getParentRoute: () => UseCasesRouteRoute,
  } as any)
const UseCasesDataSynchronizationRoute =
  UseCasesDataSynchronizationRouteImport.update({
    id: '/data-synchronization',
    path: '/data-synchronization',
    getParentRoute: () => UseCasesRouteRoute,
  } as any)
const UseCasesApiManagementRoute = UseCasesApiManagementRouteImport.update({
  id: '/api-management',
  path: '/api-management',
  getParentRoute: () => UseCasesRouteRoute,
} as any)
const UseCasesAiAutomationRoute = UseCasesAiAutomationRouteImport.update({
  id: '/ai-automation',
  path: '/ai-automation',
  getParentRoute: () => UseCasesRouteRoute,
} as any)
const LegalTermsRoute = LegalTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => LegalRouteRoute,
} as any)
const LegalSecurityRoute = LegalSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => LegalRouteRoute,
} as any)
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => LegalRouteRoute,
} as any)
const LegalComplianceRoute = LegalComplianceRouteImport.update({
  id: '/compliance',
  path: '/compliance',
  getParentRoute: () => LegalRouteRoute,
} as any)
const InfoPricingRoute = InfoPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => InfoRouteRoute,
} as any)
const InfoContactRoute = InfoContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => InfoRouteRoute,
} as any)
const InfoCareersRoute = InfoCareersRouteImport.update({
  id: '/careers',
  path: '/careers',
  getParentRoute: () => InfoRouteRoute,
} as any)
const InfoAboutRoute = InfoAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => InfoRouteRoute,
} as any)
const FeaturesWorkflowEngineRoute = FeaturesWorkflowEngineRouteImport.update({
  id: '/workflow-engine',
  path: '/workflow-engine',
  getParentRoute: () => FeaturesRouteRoute,
} as any)
const FeaturesSsoSamlRoute = FeaturesSsoSamlRouteImport.update({
  id: '/sso-saml',
  path: '/sso-saml',
  getParentRoute: () => FeaturesRouteRoute,
} as any)
const FeaturesSecurityRoute = FeaturesSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => FeaturesRouteRoute,
} as any)
const FeaturesIntegrationsRoute = FeaturesIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => FeaturesRouteRoute,
} as any)
const FeaturesAnalyticsRoute = FeaturesAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => FeaturesRouteRoute,
} as any)
const FeaturesAiGatewayRoute = FeaturesAiGatewayRouteImport.update({
  id: '/ai-gateway',
  path: '/ai-gateway',
  getParentRoute: () => FeaturesRouteRoute,
} as any)
const FeaturesAgentsPlatformRoute = FeaturesAgentsPlatformRouteImport.update({
  id: '/agents-platform',
  path: '/agents-platform',
  getParentRoute: () => FeaturesRouteRoute,
} as any)
const ConceptsZeroTrustSecurityRoute =
  ConceptsZeroTrustSecurityRouteImport.update({
    id: '/zero-trust-security',
    path: '/zero-trust-security',
    getParentRoute: () => ConceptsRouteRoute,
  } as any)
const ConceptsWorkflowAutomationRoute =
  ConceptsWorkflowAutomationRouteImport.update({
    id: '/workflow-automation',
    path: '/workflow-automation',
    getParentRoute: () => ConceptsRouteRoute,
  } as any)
const ConceptsWebhooksRoute = ConceptsWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => ConceptsRouteRoute,
} as any)
const ConceptsRbacAbacRoute = ConceptsRbacAbacRouteImport.update({
  id: '/rbac-abac',
  path: '/rbac-abac',
  getParentRoute: () => ConceptsRouteRoute,
} as any)
const ConceptsDataIntegrationRoute = ConceptsDataIntegrationRouteImport.update({
  id: '/data-integration',
  path: '/data-integration',
  getParentRoute: () => ConceptsRouteRoute,
} as any)
const ConceptsApiManagementRoute = ConceptsApiManagementRouteImport.update({
  id: '/api-management',
  path: '/api-management',
  getParentRoute: () => ConceptsRouteRoute,
} as any)
const ConceptsApiGatewayRoute = ConceptsApiGatewayRouteImport.update({
  id: '/api-gateway',
  path: '/api-gateway',
  getParentRoute: () => ConceptsRouteRoute,
} as any)
const ConceptsAiAgentsRoute = ConceptsAiAgentsRouteImport.update({
  id: '/ai-agents',
  path: '/ai-agents',
  getParentRoute: () => ConceptsRouteRoute,
} as any)
const ComparisonsLangfuseRoute = ComparisonsLangfuseRouteImport.update({
  id: '/langfuse',
  path: '/langfuse',
  getParentRoute: () => ComparisonsRouteRoute,
} as any)
const ComparisonsLangchainRoute = ComparisonsLangchainRouteImport.update({
  id: '/langchain',
  path: '/langchain',
  getParentRoute: () => ComparisonsRouteRoute,
} as any)
const ComparisonsKongRoute = ComparisonsKongRouteImport.update({
  id: '/kong',
  path: '/kong',
  getParentRoute: () => ComparisonsRouteRoute,
} as any)
const ComparisonsAwsApiGatewayRoute =
  ComparisonsAwsApiGatewayRouteImport.update({
    id: '/aws-api-gateway',
    path: '/aws-api-gateway',
    getParentRoute: () => ComparisonsRouteRoute,
  } as any)
const ComparisonsApigeeRoute = ComparisonsApigeeRouteImport.update({
  id: '/apigee',
  path: '/apigee',
  getParentRoute: () => ComparisonsRouteRoute,
} as any)
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardProfileRoute = DashboardProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardOverviewRoute = DashboardOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardApiKeysRoute = DashboardApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardAnalyticsRoute = DashboardAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => AuthRouteRoute,
} as any)
const DashboardAdminRouteRoute = DashboardAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardToolsIndexRoute = DashboardToolsIndexRouteImport.update({
  id: '/tools/',
  path: '/tools/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardMarketplaceIndexRoute =
  DashboardMarketplaceIndexRouteImport.update({
    id: '/marketplace/',
    path: '/marketplace/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardIntegrationsIndexRoute =
  DashboardIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardEnvironmentsIndexRoute =
  DashboardEnvironmentsIndexRouteImport.update({
    id: '/environments/',
    path: '/environments/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardDocsIndexRoute = DashboardDocsIndexRouteImport.update({
  id: '/docs/',
  path: '/docs/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardDataIndexRoute = DashboardDataIndexRouteImport.update({
  id: '/data/',
  path: '/data/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardCrewsIndexRoute = DashboardCrewsIndexRouteImport.update({
  id: '/crews/',
  path: '/crews/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardConnectorsIndexRoute =
  DashboardConnectorsIndexRouteImport.update({
    id: '/connectors/',
    path: '/connectors/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardAgentsIndexRoute = DashboardAgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardAdminIndexRoute = DashboardAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)
const DashboardToolsBuilderRoute = DashboardToolsBuilderRouteImport.update({
  id: '/tools/builder',
  path: '/tools/builder',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardToolsIdRoute = DashboardToolsIdRouteImport.update({
  id: '/tools/$id',
  path: '/tools/$id',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardMarketplaceMyInstallsRoute =
  DashboardMarketplaceMyInstallsRouteImport.update({
    id: '/marketplace/my-installs',
    path: '/marketplace/my-installs',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardMarketplaceSlugRoute =
  DashboardMarketplaceSlugRouteImport.update({
    id: '/marketplace/$slug',
    path: '/marketplace/$slug',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardIntegrationsCallbackRoute =
  DashboardIntegrationsCallbackRouteImport.update({
    id: '/integrations/callback',
    path: '/integrations/callback',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardIntegrationsAddRoute =
  DashboardIntegrationsAddRouteImport.update({
    id: '/integrations/add',
    path: '/integrations/add',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardIntegrationsProviderRoute =
  DashboardIntegrationsProviderRouteImport.update({
    id: '/integrations/$provider',
    path: '/integrations/$provider',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardEnvironmentsIdRoute = DashboardEnvironmentsIdRouteImport.update({
  id: '/environments/$id',
  path: '/environments/$id',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardDocsSplatRoute = DashboardDocsSplatRouteImport.update({
  id: '/docs/$',
  path: '/docs/$',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardDataAliasRoute = DashboardDataAliasRouteImport.update({
  id: '/data/$alias',
  path: '/data/$alias',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardDataSplatRoute = DashboardDataSplatRouteImport.update({
  id: '/data/$',
  path: '/data/$',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardCrewsCreateRoute = DashboardCrewsCreateRouteImport.update({
  id: '/crews/create',
  path: '/crews/create',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardConnectorsNewRoute = DashboardConnectorsNewRouteImport.update({
  id: '/connectors/new',
  path: '/connectors/new',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardConnectorsConnectorIdRoute =
  DashboardConnectorsConnectorIdRouteImport.update({
    id: '/connectors/$connectorId',
    path: '/connectors/$connectorId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardAdminAuditRoute = DashboardAdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)
const DashboardAgentsCreateRouteRoute =
  DashboardAgentsCreateRouteRouteImport.update({
    id: '/agents/create',
    path: '/agents/create',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardAgentsCreateIndexRoute =
  DashboardAgentsCreateIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardAgentsCreateRouteRoute,
  } as any)
const DashboardAgentsIdIndexRoute = DashboardAgentsIdIndexRouteImport.update({
  id: '/agents/$id/',
  path: '/agents/$id/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardAdminSuperadminIndexRoute =
  DashboardAdminSuperadminIndexRouteImport.update({
    id: '/superadmin/',
    path: '/superadmin/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminOrgIndexRoute = DashboardAdminOrgIndexRouteImport.update({
  id: '/org/',
  path: '/org/',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)
const DashboardAgentsCreateJsonRoute =
  DashboardAgentsCreateJsonRouteImport.update({
    id: '/json',
    path: '/json',
    getParentRoute: () => DashboardAgentsCreateRouteRoute,
  } as any)
const DashboardAgentsCreateFormRoute =
  DashboardAgentsCreateFormRouteImport.update({
    id: '/form',
    path: '/form',
    getParentRoute: () => DashboardAgentsCreateRouteRoute,
  } as any)
const DashboardAgentsCreateCanvasRoute =
  DashboardAgentsCreateCanvasRouteImport.update({
    id: '/canvas',
    path: '/canvas',
    getParentRoute: () => DashboardAgentsCreateRouteRoute,
  } as any)
const DashboardAgentsCreateAiRoute = DashboardAgentsCreateAiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => DashboardAgentsCreateRouteRoute,
} as any)
const DashboardAgentsIdChatRoute = DashboardAgentsIdChatRouteImport.update({
  id: '/agents/$id/chat',
  path: '/agents/$id/chat',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardAdminSuperadminUsersRoute =
  DashboardAdminSuperadminUsersRouteImport.update({
    id: '/superadmin/users',
    path: '/superadmin/users',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminSuperadminSystemRoute =
  DashboardAdminSuperadminSystemRouteImport.update({
    id: '/superadmin/system',
    path: '/superadmin/system',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminSuperadminOrganizationsRoute =
  DashboardAdminSuperadminOrganizationsRouteImport.update({
    id: '/superadmin/organizations',
    path: '/superadmin/organizations',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminOrgUsersRoute = DashboardAdminOrgUsersRouteImport.update({
  id: '/org/users',
  path: '/org/users',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)
const DashboardAdminOrgSsoRoute = DashboardAdminOrgSsoRouteImport.update({
  id: '/org/sso',
  path: '/org/sso',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)
const DashboardAdminOrgSecurityRoute =
  DashboardAdminOrgSecurityRouteImport.update({
    id: '/org/security',
    path: '/org/security',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminOrgSdkKeysRoute =
  DashboardAdminOrgSdkKeysRouteImport.update({
    id: '/org/sdk-keys',
    path: '/org/sdk-keys',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminOrgScimRoute = DashboardAdminOrgScimRouteImport.update({
  id: '/org/scim',
  path: '/org/scim',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)
const DashboardAdminOrgRolesRoute = DashboardAdminOrgRolesRouteImport.update({
  id: '/org/roles',
  path: '/org/roles',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)
const DashboardAdminOrgPoliciesRoute =
  DashboardAdminOrgPoliciesRouteImport.update({
    id: '/org/policies',
    path: '/org/policies',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminOrgApiKeysRoute =
  DashboardAdminOrgApiKeysRouteImport.update({
    id: '/org/api-keys',
    path: '/org/api-keys',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminDataRedisRoute = DashboardAdminDataRedisRouteImport.update({
  id: '/data/redis',
  path: '/data/redis',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)
const DashboardAdminDataPostgresRoute =
  DashboardAdminDataPostgresRouteImport.update({
    id: '/data/postgres',
    path: '/data/postgres',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminDataClickhouseRoute =
  DashboardAdminDataClickhouseRouteImport.update({
    id: '/data/clickhouse',
    path: '/data/clickhouse',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/comparisons': typeof ComparisonsRouteRouteWithChildren
  '/concepts': typeof ConceptsRouteRouteWithChildren
  '/features': typeof FeaturesRouteRouteWithChildren
  '/info': typeof InfoRouteRouteWithChildren
  '/legal': typeof LegalRouteRouteWithChildren
  '/use-cases': typeof UseCasesRouteRouteWithChildren
  '/device-auth': typeof DeviceAuthRoute
  '/admin': typeof DashboardAdminRouteRouteWithChildren
  '/callback': typeof AuthCallbackRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/analytics': typeof DashboardAnalyticsRoute
  '/api-keys': typeof DashboardApiKeysRoute
  '/overview': typeof DashboardOverviewRoute
  '/profile': typeof DashboardProfileRoute
  '/settings': typeof DashboardSettingsRoute
  '/comparisons/apigee': typeof ComparisonsApigeeRoute
  '/comparisons/aws-api-gateway': typeof ComparisonsAwsApiGatewayRoute
  '/comparisons/kong': typeof ComparisonsKongRoute
  '/comparisons/langchain': typeof ComparisonsLangchainRoute
  '/comparisons/langfuse': typeof ComparisonsLangfuseRoute
  '/concepts/ai-agents': typeof ConceptsAiAgentsRoute
  '/concepts/api-gateway': typeof ConceptsApiGatewayRoute
  '/concepts/api-management': typeof ConceptsApiManagementRoute
  '/concepts/data-integration': typeof ConceptsDataIntegrationRoute
  '/concepts/rbac-abac': typeof ConceptsRbacAbacRoute
  '/concepts/webhooks': typeof ConceptsWebhooksRoute
  '/concepts/workflow-automation': typeof ConceptsWorkflowAutomationRoute
  '/concepts/zero-trust-security': typeof ConceptsZeroTrustSecurityRoute
  '/features/agents-platform': typeof FeaturesAgentsPlatformRoute
  '/features/ai-gateway': typeof FeaturesAiGatewayRoute
  '/features/analytics': typeof FeaturesAnalyticsRoute
  '/features/integrations': typeof FeaturesIntegrationsRoute
  '/features/security': typeof FeaturesSecurityRoute
  '/features/sso-saml': typeof FeaturesSsoSamlRoute
  '/features/workflow-engine': typeof FeaturesWorkflowEngineRoute
  '/info/about': typeof InfoAboutRoute
  '/info/careers': typeof InfoCareersRoute
  '/info/contact': typeof InfoContactRoute
  '/info/pricing': typeof InfoPricingRoute
  '/legal/compliance': typeof LegalComplianceRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/security': typeof LegalSecurityRoute
  '/legal/terms': typeof LegalTermsRoute
  '/use-cases/ai-automation': typeof UseCasesAiAutomationRoute
  '/use-cases/api-management': typeof UseCasesApiManagementRoute
  '/use-cases/data-synchronization': typeof UseCasesDataSynchronizationRoute
  '/use-cases/enterprise-security': typeof UseCasesEnterpriseSecurityRoute
  '/use-cases/finops': typeof UseCasesFinopsRoute
  '/comparisons/': typeof ComparisonsIndexRoute
  '/concepts/': typeof ConceptsIndexRoute
  '/features/': typeof FeaturesIndexRoute
  '/legal/': typeof LegalIndexRoute
  '/use-cases/': typeof UseCasesIndexRoute
  '/agents/create': typeof DashboardAgentsCreateRouteRouteWithChildren
  '/admin/audit': typeof DashboardAdminAuditRoute
  '/connectors/$connectorId': typeof DashboardConnectorsConnectorIdRoute
  '/connectors/new': typeof DashboardConnectorsNewRoute
  '/crews/create': typeof DashboardCrewsCreateRoute
  '/data/$': typeof DashboardDataSplatRoute
  '/data/$alias': typeof DashboardDataAliasRoute
  '/docs/$': typeof DashboardDocsSplatRoute
  '/environments/$id': typeof DashboardEnvironmentsIdRoute
  '/integrations/$provider': typeof DashboardIntegrationsProviderRoute
  '/integrations/add': typeof DashboardIntegrationsAddRoute
  '/integrations/callback': typeof DashboardIntegrationsCallbackRoute
  '/marketplace/$slug': typeof DashboardMarketplaceSlugRoute
  '/marketplace/my-installs': typeof DashboardMarketplaceMyInstallsRoute
  '/tools/$id': typeof DashboardToolsIdRoute
  '/tools/builder': typeof DashboardToolsBuilderRoute
  '/admin/': typeof DashboardAdminIndexRoute
  '/agents': typeof DashboardAgentsIndexRoute
  '/connectors': typeof DashboardConnectorsIndexRoute
  '/crews': typeof DashboardCrewsIndexRoute
  '/data': typeof DashboardDataIndexRoute
  '/docs': typeof DashboardDocsIndexRoute
  '/environments': typeof DashboardEnvironmentsIndexRoute
  '/integrations': typeof DashboardIntegrationsIndexRoute
  '/marketplace': typeof DashboardMarketplaceIndexRoute
  '/tools': typeof DashboardToolsIndexRoute
  '/admin/data/clickhouse': typeof DashboardAdminDataClickhouseRoute
  '/admin/data/postgres': typeof DashboardAdminDataPostgresRoute
  '/admin/data/redis': typeof DashboardAdminDataRedisRoute
  '/admin/org/api-keys': typeof DashboardAdminOrgApiKeysRoute
  '/admin/org/policies': typeof DashboardAdminOrgPoliciesRoute
  '/admin/org/roles': typeof DashboardAdminOrgRolesRoute
  '/admin/org/scim': typeof DashboardAdminOrgScimRoute
  '/admin/org/sdk-keys': typeof DashboardAdminOrgSdkKeysRoute
  '/admin/org/security': typeof DashboardAdminOrgSecurityRoute
  '/admin/org/sso': typeof DashboardAdminOrgSsoRoute
  '/admin/org/users': typeof DashboardAdminOrgUsersRoute
  '/admin/superadmin/organizations': typeof DashboardAdminSuperadminOrganizationsRoute
  '/admin/superadmin/system': typeof DashboardAdminSuperadminSystemRoute
  '/admin/superadmin/users': typeof DashboardAdminSuperadminUsersRoute
  '/agents/$id/chat': typeof DashboardAgentsIdChatRoute
  '/agents/create/ai': typeof DashboardAgentsCreateAiRoute
  '/agents/create/canvas': typeof DashboardAgentsCreateCanvasRoute
  '/agents/create/form': typeof DashboardAgentsCreateFormRoute
  '/agents/create/json': typeof DashboardAgentsCreateJsonRoute
  '/admin/org': typeof DashboardAdminOrgIndexRoute
  '/admin/superadmin': typeof DashboardAdminSuperadminIndexRoute
  '/agents/$id': typeof DashboardAgentsIdIndexRoute
  '/agents/create/': typeof DashboardAgentsCreateIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/info': typeof InfoRouteRouteWithChildren
  '/device-auth': typeof DeviceAuthRoute
  '/callback': typeof AuthCallbackRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/analytics': typeof DashboardAnalyticsRoute
  '/api-keys': typeof DashboardApiKeysRoute
  '/overview': typeof DashboardOverviewRoute
  '/profile': typeof DashboardProfileRoute
  '/settings': typeof DashboardSettingsRoute
  '/comparisons/apigee': typeof ComparisonsApigeeRoute
  '/comparisons/aws-api-gateway': typeof ComparisonsAwsApiGatewayRoute
  '/comparisons/kong': typeof ComparisonsKongRoute
  '/comparisons/langchain': typeof ComparisonsLangchainRoute
  '/comparisons/langfuse': typeof ComparisonsLangfuseRoute
  '/concepts/ai-agents': typeof ConceptsAiAgentsRoute
  '/concepts/api-gateway': typeof ConceptsApiGatewayRoute
  '/concepts/api-management': typeof ConceptsApiManagementRoute
  '/concepts/data-integration': typeof ConceptsDataIntegrationRoute
  '/concepts/rbac-abac': typeof ConceptsRbacAbacRoute
  '/concepts/webhooks': typeof ConceptsWebhooksRoute
  '/concepts/workflow-automation': typeof ConceptsWorkflowAutomationRoute
  '/concepts/zero-trust-security': typeof ConceptsZeroTrustSecurityRoute
  '/features/agents-platform': typeof FeaturesAgentsPlatformRoute
  '/features/ai-gateway': typeof FeaturesAiGatewayRoute
  '/features/analytics': typeof FeaturesAnalyticsRoute
  '/features/integrations': typeof FeaturesIntegrationsRoute
  '/features/security': typeof FeaturesSecurityRoute
  '/features/sso-saml': typeof FeaturesSsoSamlRoute
  '/features/workflow-engine': typeof FeaturesWorkflowEngineRoute
  '/info/about': typeof InfoAboutRoute
  '/info/careers': typeof InfoCareersRoute
  '/info/contact': typeof InfoContactRoute
  '/info/pricing': typeof InfoPricingRoute
  '/legal/compliance': typeof LegalComplianceRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/security': typeof LegalSecurityRoute
  '/legal/terms': typeof LegalTermsRoute
  '/use-cases/ai-automation': typeof UseCasesAiAutomationRoute
  '/use-cases/api-management': typeof UseCasesApiManagementRoute
  '/use-cases/data-synchronization': typeof UseCasesDataSynchronizationRoute
  '/use-cases/enterprise-security': typeof UseCasesEnterpriseSecurityRoute
  '/use-cases/finops': typeof UseCasesFinopsRoute
  '/comparisons': typeof ComparisonsIndexRoute
  '/concepts': typeof ConceptsIndexRoute
  '/features': typeof FeaturesIndexRoute
  '/legal': typeof LegalIndexRoute
  '/use-cases': typeof UseCasesIndexRoute
  '/admin/audit': typeof DashboardAdminAuditRoute
  '/connectors/$connectorId': typeof DashboardConnectorsConnectorIdRoute
  '/connectors/new': typeof DashboardConnectorsNewRoute
  '/crews/create': typeof DashboardCrewsCreateRoute
  '/data/$': typeof DashboardDataSplatRoute
  '/data/$alias': typeof DashboardDataAliasRoute
  '/docs/$': typeof DashboardDocsSplatRoute
  '/environments/$id': typeof DashboardEnvironmentsIdRoute
  '/integrations/$provider': typeof DashboardIntegrationsProviderRoute
  '/integrations/add': typeof DashboardIntegrationsAddRoute
  '/integrations/callback': typeof DashboardIntegrationsCallbackRoute
  '/marketplace/$slug': typeof DashboardMarketplaceSlugRoute
  '/marketplace/my-installs': typeof DashboardMarketplaceMyInstallsRoute
  '/tools/$id': typeof DashboardToolsIdRoute
  '/tools/builder': typeof DashboardToolsBuilderRoute
  '/admin': typeof DashboardAdminIndexRoute
  '/agents': typeof DashboardAgentsIndexRoute
  '/connectors': typeof DashboardConnectorsIndexRoute
  '/crews': typeof DashboardCrewsIndexRoute
  '/data': typeof DashboardDataIndexRoute
  '/docs': typeof DashboardDocsIndexRoute
  '/environments': typeof DashboardEnvironmentsIndexRoute
  '/integrations': typeof DashboardIntegrationsIndexRoute
  '/marketplace': typeof DashboardMarketplaceIndexRoute
  '/tools': typeof DashboardToolsIndexRoute
  '/admin/data/clickhouse': typeof DashboardAdminDataClickhouseRoute
  '/admin/data/postgres': typeof DashboardAdminDataPostgresRoute
  '/admin/data/redis': typeof DashboardAdminDataRedisRoute
  '/admin/org/api-keys': typeof DashboardAdminOrgApiKeysRoute
  '/admin/org/policies': typeof DashboardAdminOrgPoliciesRoute
  '/admin/org/roles': typeof DashboardAdminOrgRolesRoute
  '/admin/org/scim': typeof DashboardAdminOrgScimRoute
  '/admin/org/sdk-keys': typeof DashboardAdminOrgSdkKeysRoute
  '/admin/org/security': typeof DashboardAdminOrgSecurityRoute
  '/admin/org/sso': typeof DashboardAdminOrgSsoRoute
  '/admin/org/users': typeof DashboardAdminOrgUsersRoute
  '/admin/superadmin/organizations': typeof DashboardAdminSuperadminOrganizationsRoute
  '/admin/superadmin/system': typeof DashboardAdminSuperadminSystemRoute
  '/admin/superadmin/users': typeof DashboardAdminSuperadminUsersRoute
  '/agents/$id/chat': typeof DashboardAgentsIdChatRoute
  '/agents/create/ai': typeof DashboardAgentsCreateAiRoute
  '/agents/create/canvas': typeof DashboardAgentsCreateCanvasRoute
  '/agents/create/form': typeof DashboardAgentsCreateFormRoute
  '/agents/create/json': typeof DashboardAgentsCreateJsonRoute
  '/admin/org': typeof DashboardAdminOrgIndexRoute
  '/admin/superadmin': typeof DashboardAdminSuperadminIndexRoute
  '/agents/$id': typeof DashboardAgentsIdIndexRoute
  '/agents/create': typeof DashboardAgentsCreateIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteRouteWithChildren
  '/_dashboard': typeof DashboardRouteRouteWithChildren
  '/comparisons': typeof ComparisonsRouteRouteWithChildren
  '/concepts': typeof ConceptsRouteRouteWithChildren
  '/features': typeof FeaturesRouteRouteWithChildren
  '/info': typeof InfoRouteRouteWithChildren
  '/legal': typeof LegalRouteRouteWithChildren
  '/use-cases': typeof UseCasesRouteRouteWithChildren
  '/device-auth': typeof DeviceAuthRoute
  '/_dashboard/admin': typeof DashboardAdminRouteRouteWithChildren
  '/_auth/callback': typeof AuthCallbackRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_dashboard/analytics': typeof DashboardAnalyticsRoute
  '/_dashboard/api-keys': typeof DashboardApiKeysRoute
  '/_dashboard/overview': typeof DashboardOverviewRoute
  '/_dashboard/profile': typeof DashboardProfileRoute
  '/_dashboard/settings': typeof DashboardSettingsRoute
  '/comparisons/apigee': typeof ComparisonsApigeeRoute
  '/comparisons/aws-api-gateway': typeof ComparisonsAwsApiGatewayRoute
  '/comparisons/kong': typeof ComparisonsKongRoute
  '/comparisons/langchain': typeof ComparisonsLangchainRoute
  '/comparisons/langfuse': typeof ComparisonsLangfuseRoute
  '/concepts/ai-agents': typeof ConceptsAiAgentsRoute
  '/concepts/api-gateway': typeof ConceptsApiGatewayRoute
  '/concepts/api-management': typeof ConceptsApiManagementRoute
  '/concepts/data-integration': typeof ConceptsDataIntegrationRoute
  '/concepts/rbac-abac': typeof ConceptsRbacAbacRoute
  '/concepts/webhooks': typeof ConceptsWebhooksRoute
  '/concepts/workflow-automation': typeof ConceptsWorkflowAutomationRoute
  '/concepts/zero-trust-security': typeof ConceptsZeroTrustSecurityRoute
  '/features/agents-platform': typeof FeaturesAgentsPlatformRoute
  '/features/ai-gateway': typeof FeaturesAiGatewayRoute
  '/features/analytics': typeof FeaturesAnalyticsRoute
  '/features/integrations': typeof FeaturesIntegrationsRoute
  '/features/security': typeof FeaturesSecurityRoute
  '/features/sso-saml': typeof FeaturesSsoSamlRoute
  '/features/workflow-engine': typeof FeaturesWorkflowEngineRoute
  '/info/about': typeof InfoAboutRoute
  '/info/careers': typeof InfoCareersRoute
  '/info/contact': typeof InfoContactRoute
  '/info/pricing': typeof InfoPricingRoute
  '/legal/compliance': typeof LegalComplianceRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/security': typeof LegalSecurityRoute
  '/legal/terms': typeof LegalTermsRoute
  '/use-cases/ai-automation': typeof UseCasesAiAutomationRoute
  '/use-cases/api-management': typeof UseCasesApiManagementRoute
  '/use-cases/data-synchronization': typeof UseCasesDataSynchronizationRoute
  '/use-cases/enterprise-security': typeof UseCasesEnterpriseSecurityRoute
  '/use-cases/finops': typeof UseCasesFinopsRoute
  '/comparisons/': typeof ComparisonsIndexRoute
  '/concepts/': typeof ConceptsIndexRoute
  '/features/': typeof FeaturesIndexRoute
  '/legal/': typeof LegalIndexRoute
  '/use-cases/': typeof UseCasesIndexRoute
  '/_dashboard/agents/create': typeof DashboardAgentsCreateRouteRouteWithChildren
  '/_dashboard/admin/audit': typeof DashboardAdminAuditRoute
  '/_dashboard/connectors/$connectorId': typeof DashboardConnectorsConnectorIdRoute
  '/_dashboard/connectors/new': typeof DashboardConnectorsNewRoute
  '/_dashboard/crews/create': typeof DashboardCrewsCreateRoute
  '/_dashboard/data/$': typeof DashboardDataSplatRoute
  '/_dashboard/data/$alias': typeof DashboardDataAliasRoute
  '/_dashboard/docs/$': typeof DashboardDocsSplatRoute
  '/_dashboard/environments/$id': typeof DashboardEnvironmentsIdRoute
  '/_dashboard/integrations/$provider': typeof DashboardIntegrationsProviderRoute
  '/_dashboard/integrations/add': typeof DashboardIntegrationsAddRoute
  '/_dashboard/integrations/callback': typeof DashboardIntegrationsCallbackRoute
  '/_dashboard/marketplace/$slug': typeof DashboardMarketplaceSlugRoute
  '/_dashboard/marketplace/my-installs': typeof DashboardMarketplaceMyInstallsRoute
  '/_dashboard/tools/$id': typeof DashboardToolsIdRoute
  '/_dashboard/tools/builder': typeof DashboardToolsBuilderRoute
  '/_dashboard/admin/': typeof DashboardAdminIndexRoute
  '/_dashboard/agents/': typeof DashboardAgentsIndexRoute
  '/_dashboard/connectors/': typeof DashboardConnectorsIndexRoute
  '/_dashboard/crews/': typeof DashboardCrewsIndexRoute
  '/_dashboard/data/': typeof DashboardDataIndexRoute
  '/_dashboard/docs/': typeof DashboardDocsIndexRoute
  '/_dashboard/environments/': typeof DashboardEnvironmentsIndexRoute
  '/_dashboard/integrations/': typeof DashboardIntegrationsIndexRoute
  '/_dashboard/marketplace/': typeof DashboardMarketplaceIndexRoute
  '/_dashboard/tools/': typeof DashboardToolsIndexRoute
  '/_dashboard/admin/data/clickhouse': typeof DashboardAdminDataClickhouseRoute
  '/_dashboard/admin/data/postgres': typeof DashboardAdminDataPostgresRoute
  '/_dashboard/admin/data/redis': typeof DashboardAdminDataRedisRoute
  '/_dashboard/admin/org/api-keys': typeof DashboardAdminOrgApiKeysRoute
  '/_dashboard/admin/org/policies': typeof DashboardAdminOrgPoliciesRoute
  '/_dashboard/admin/org/roles': typeof DashboardAdminOrgRolesRoute
  '/_dashboard/admin/org/scim': typeof DashboardAdminOrgScimRoute
  '/_dashboard/admin/org/sdk-keys': typeof DashboardAdminOrgSdkKeysRoute
  '/_dashboard/admin/org/security': typeof DashboardAdminOrgSecurityRoute
  '/_dashboard/admin/org/sso': typeof DashboardAdminOrgSsoRoute
  '/_dashboard/admin/org/users': typeof DashboardAdminOrgUsersRoute
  '/_dashboard/admin/superadmin/organizations': typeof DashboardAdminSuperadminOrganizationsRoute
  '/_dashboard/admin/superadmin/system': typeof DashboardAdminSuperadminSystemRoute
  '/_dashboard/admin/superadmin/users': typeof DashboardAdminSuperadminUsersRoute
  '/_dashboard/agents/$id/chat': typeof DashboardAgentsIdChatRoute
  '/_dashboard/agents/create/ai': typeof DashboardAgentsCreateAiRoute
  '/_dashboard/agents/create/canvas': typeof DashboardAgentsCreateCanvasRoute
  '/_dashboard/agents/create/form': typeof DashboardAgentsCreateFormRoute
  '/_dashboard/agents/create/json': typeof DashboardAgentsCreateJsonRoute
  '/_dashboard/admin/org/': typeof DashboardAdminOrgIndexRoute
  '/_dashboard/admin/superadmin/': typeof DashboardAdminSuperadminIndexRoute
  '/_dashboard/agents/$id/': typeof DashboardAgentsIdIndexRoute
  '/_dashboard/agents/create/': typeof DashboardAgentsCreateIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/comparisons'
    | '/concepts'
    | '/features'
    | '/info'
    | '/legal'
    | '/use-cases'
    | '/device-auth'
    | '/admin'
    | '/callback'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/analytics'
    | '/api-keys'
    | '/overview'
    | '/profile'
    | '/settings'
    | '/comparisons/apigee'
    | '/comparisons/aws-api-gateway'
    | '/comparisons/kong'
    | '/comparisons/langchain'
    | '/comparisons/langfuse'
    | '/concepts/ai-agents'
    | '/concepts/api-gateway'
    | '/concepts/api-management'
    | '/concepts/data-integration'
    | '/concepts/rbac-abac'
    | '/concepts/webhooks'
    | '/concepts/workflow-automation'
    | '/concepts/zero-trust-security'
    | '/features/agents-platform'
    | '/features/ai-gateway'
    | '/features/analytics'
    | '/features/integrations'
    | '/features/security'
    | '/features/sso-saml'
    | '/features/workflow-engine'
    | '/info/about'
    | '/info/careers'
    | '/info/contact'
    | '/info/pricing'
    | '/legal/compliance'
    | '/legal/privacy'
    | '/legal/security'
    | '/legal/terms'
    | '/use-cases/ai-automation'
    | '/use-cases/api-management'
    | '/use-cases/data-synchronization'
    | '/use-cases/enterprise-security'
    | '/use-cases/finops'
    | '/comparisons/'
    | '/concepts/'
    | '/features/'
    | '/legal/'
    | '/use-cases/'
    | '/agents/create'
    | '/admin/audit'
    | '/connectors/$connectorId'
    | '/connectors/new'
    | '/crews/create'
    | '/data/$'
    | '/data/$alias'
    | '/docs/$'
    | '/environments/$id'
    | '/integrations/$provider'
    | '/integrations/add'
    | '/integrations/callback'
    | '/marketplace/$slug'
    | '/marketplace/my-installs'
    | '/tools/$id'
    | '/tools/builder'
    | '/admin/'
    | '/agents'
    | '/connectors'
    | '/crews'
    | '/data'
    | '/docs'
    | '/environments'
    | '/integrations'
    | '/marketplace'
    | '/tools'
    | '/admin/data/clickhouse'
    | '/admin/data/postgres'
    | '/admin/data/redis'
    | '/admin/org/api-keys'
    | '/admin/org/policies'
    | '/admin/org/roles'
    | '/admin/org/scim'
    | '/admin/org/sdk-keys'
    | '/admin/org/security'
    | '/admin/org/sso'
    | '/admin/org/users'
    | '/admin/superadmin/organizations'
    | '/admin/superadmin/system'
    | '/admin/superadmin/users'
    | '/agents/$id/chat'
    | '/agents/create/ai'
    | '/agents/create/canvas'
    | '/agents/create/form'
    | '/agents/create/json'
    | '/admin/org'
    | '/admin/superadmin'
    | '/agents/$id'
    | '/agents/create/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/info'
    | '/device-auth'
    | '/callback'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/analytics'
    | '/api-keys'
    | '/overview'
    | '/profile'
    | '/settings'
    | '/comparisons/apigee'
    | '/comparisons/aws-api-gateway'
    | '/comparisons/kong'
    | '/comparisons/langchain'
    | '/comparisons/langfuse'
    | '/concepts/ai-agents'
    | '/concepts/api-gateway'
    | '/concepts/api-management'
    | '/concepts/data-integration'
    | '/concepts/rbac-abac'
    | '/concepts/webhooks'
    | '/concepts/workflow-automation'
    | '/concepts/zero-trust-security'
    | '/features/agents-platform'
    | '/features/ai-gateway'
    | '/features/analytics'
    | '/features/integrations'
    | '/features/security'
    | '/features/sso-saml'
    | '/features/workflow-engine'
    | '/info/about'
    | '/info/careers'
    | '/info/contact'
    | '/info/pricing'
    | '/legal/compliance'
    | '/legal/privacy'
    | '/legal/security'
    | '/legal/terms'
    | '/use-cases/ai-automation'
    | '/use-cases/api-management'
    | '/use-cases/data-synchronization'
    | '/use-cases/enterprise-security'
    | '/use-cases/finops'
    | '/comparisons'
    | '/concepts'
    | '/features'
    | '/legal'
    | '/use-cases'
    | '/admin/audit'
    | '/connectors/$connectorId'
    | '/connectors/new'
    | '/crews/create'
    | '/data/$'
    | '/data/$alias'
    | '/docs/$'
    | '/environments/$id'
    | '/integrations/$provider'
    | '/integrations/add'
    | '/integrations/callback'
    | '/marketplace/$slug'
    | '/marketplace/my-installs'
    | '/tools/$id'
    | '/tools/builder'
    | '/admin'
    | '/agents'
    | '/connectors'
    | '/crews'
    | '/data'
    | '/docs'
    | '/environments'
    | '/integrations'
    | '/marketplace'
    | '/tools'
    | '/admin/data/clickhouse'
    | '/admin/data/postgres'
    | '/admin/data/redis'
    | '/admin/org/api-keys'
    | '/admin/org/policies'
    | '/admin/org/roles'
    | '/admin/org/scim'
    | '/admin/org/sdk-keys'
    | '/admin/org/security'
    | '/admin/org/sso'
    | '/admin/org/users'
    | '/admin/superadmin/organizations'
    | '/admin/superadmin/system'
    | '/admin/superadmin/users'
    | '/agents/$id/chat'
    | '/agents/create/ai'
    | '/agents/create/canvas'
    | '/agents/create/form'
    | '/agents/create/json'
    | '/admin/org'
    | '/admin/superadmin'
    | '/agents/$id'
    | '/agents/create'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_dashboard'
    | '/comparisons'
    | '/concepts'
    | '/features'
    | '/info'
    | '/legal'
    | '/use-cases'
    | '/device-auth'
    | '/_dashboard/admin'
    | '/_auth/callback'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/reset-password'
    | '/_dashboard/analytics'
    | '/_dashboard/api-keys'
    | '/_dashboard/overview'
    | '/_dashboard/profile'
    | '/_dashboard/settings'
    | '/comparisons/apigee'
    | '/comparisons/aws-api-gateway'
    | '/comparisons/kong'
    | '/comparisons/langchain'
    | '/comparisons/langfuse'
    | '/concepts/ai-agents'
    | '/concepts/api-gateway'
    | '/concepts/api-management'
    | '/concepts/data-integration'
    | '/concepts/rbac-abac'
    | '/concepts/webhooks'
    | '/concepts/workflow-automation'
    | '/concepts/zero-trust-security'
    | '/features/agents-platform'
    | '/features/ai-gateway'
    | '/features/analytics'
    | '/features/integrations'
    | '/features/security'
    | '/features/sso-saml'
    | '/features/workflow-engine'
    | '/info/about'
    | '/info/careers'
    | '/info/contact'
    | '/info/pricing'
    | '/legal/compliance'
    | '/legal/privacy'
    | '/legal/security'
    | '/legal/terms'
    | '/use-cases/ai-automation'
    | '/use-cases/api-management'
    | '/use-cases/data-synchronization'
    | '/use-cases/enterprise-security'
    | '/use-cases/finops'
    | '/comparisons/'
    | '/concepts/'
    | '/features/'
    | '/legal/'
    | '/use-cases/'
    | '/_dashboard/agents/create'
    | '/_dashboard/admin/audit'
    | '/_dashboard/connectors/$connectorId'
    | '/_dashboard/connectors/new'
    | '/_dashboard/crews/create'
    | '/_dashboard/data/$'
    | '/_dashboard/data/$alias'
    | '/_dashboard/docs/$'
    | '/_dashboard/environments/$id'
    | '/_dashboard/integrations/$provider'
    | '/_dashboard/integrations/add'
    | '/_dashboard/integrations/callback'
    | '/_dashboard/marketplace/$slug'
    | '/_dashboard/marketplace/my-installs'
    | '/_dashboard/tools/$id'
    | '/_dashboard/tools/builder'
    | '/_dashboard/admin/'
    | '/_dashboard/agents/'
    | '/_dashboard/connectors/'
    | '/_dashboard/crews/'
    | '/_dashboard/data/'
    | '/_dashboard/docs/'
    | '/_dashboard/environments/'
    | '/_dashboard/integrations/'
    | '/_dashboard/marketplace/'
    | '/_dashboard/tools/'
    | '/_dashboard/admin/data/clickhouse'
    | '/_dashboard/admin/data/postgres'
    | '/_dashboard/admin/data/redis'
    | '/_dashboard/admin/org/api-keys'
    | '/_dashboard/admin/org/policies'
    | '/_dashboard/admin/org/roles'
    | '/_dashboard/admin/org/scim'
    | '/_dashboard/admin/org/sdk-keys'
    | '/_dashboard/admin/org/security'
    | '/_dashboard/admin/org/sso'
    | '/_dashboard/admin/org/users'
    | '/_dashboard/admin/superadmin/organizations'
    | '/_dashboard/admin/superadmin/system'
    | '/_dashboard/admin/superadmin/users'
    | '/_dashboard/agents/$id/chat'
    | '/_dashboard/agents/create/ai'
    | '/_dashboard/agents/create/canvas'
    | '/_dashboard/agents/create/form'
    | '/_dashboard/agents/create/json'
    | '/_dashboard/admin/org/'
    | '/_dashboard/admin/superadmin/'
    | '/_dashboard/agents/$id/'
    | '/_dashboard/agents/create/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  ComparisonsRouteRoute: typeof ComparisonsRouteRouteWithChildren
  ConceptsRouteRoute: typeof ConceptsRouteRouteWithChildren
  FeaturesRouteRoute: typeof FeaturesRouteRouteWithChildren
  InfoRouteRoute: typeof InfoRouteRouteWithChildren
  LegalRouteRoute: typeof LegalRouteRouteWithChildren
  UseCasesRouteRoute: typeof UseCasesRouteRouteWithChildren
  DeviceAuthRoute: typeof DeviceAuthRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/device-auth': {
      id: '/device-auth'
      path: '/device-auth'
      fullPath: '/device-auth'
      preLoaderRoute: typeof DeviceAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/use-cases': {
      id: '/use-cases'
      path: '/use-cases'
      fullPath: '/use-cases'
      preLoaderRoute: typeof UseCasesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal': {
      id: '/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof LegalRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/info': {
      id: '/info'
      path: '/info'
      fullPath: '/info'
      preLoaderRoute: typeof InfoRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/features': {
      id: '/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof FeaturesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/concepts': {
      id: '/concepts'
      path: '/concepts'
      fullPath: '/concepts'
      preLoaderRoute: typeof ConceptsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/comparisons': {
      id: '/comparisons'
      path: '/comparisons'
      fullPath: '/comparisons'
      preLoaderRoute: typeof ComparisonsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/use-cases/': {
      id: '/use-cases/'
      path: '/'
      fullPath: '/use-cases/'
      preLoaderRoute: typeof UseCasesIndexRouteImport
      parentRoute: typeof UseCasesRouteRoute
    }
    '/legal/': {
      id: '/legal/'
      path: '/'
      fullPath: '/legal/'
      preLoaderRoute: typeof LegalIndexRouteImport
      parentRoute: typeof LegalRouteRoute
    }
    '/features/': {
      id: '/features/'
      path: '/'
      fullPath: '/features/'
      preLoaderRoute: typeof FeaturesIndexRouteImport
      parentRoute: typeof FeaturesRouteRoute
    }
    '/concepts/': {
      id: '/concepts/'
      path: '/'
      fullPath: '/concepts/'
      preLoaderRoute: typeof ConceptsIndexRouteImport
      parentRoute: typeof ConceptsRouteRoute
    }
    '/comparisons/': {
      id: '/comparisons/'
      path: '/'
      fullPath: '/comparisons/'
      preLoaderRoute: typeof ComparisonsIndexRouteImport
      parentRoute: typeof ComparisonsRouteRoute
    }
    '/use-cases/finops': {
      id: '/use-cases/finops'
      path: '/finops'
      fullPath: '/use-cases/finops'
      preLoaderRoute: typeof UseCasesFinopsRouteImport
      parentRoute: typeof UseCasesRouteRoute
    }
    '/use-cases/enterprise-security': {
      id: '/use-cases/enterprise-security'
      path: '/enterprise-security'
      fullPath: '/use-cases/enterprise-security'
      preLoaderRoute: typeof UseCasesEnterpriseSecurityRouteImport
      parentRoute: typeof UseCasesRouteRoute
    }
    '/use-cases/data-synchronization': {
      id: '/use-cases/data-synchronization'
      path: '/data-synchronization'
      fullPath: '/use-cases/data-synchronization'
      preLoaderRoute: typeof UseCasesDataSynchronizationRouteImport
      parentRoute: typeof UseCasesRouteRoute
    }
    '/use-cases/api-management': {
      id: '/use-cases/api-management'
      path: '/api-management'
      fullPath: '/use-cases/api-management'
      preLoaderRoute: typeof UseCasesApiManagementRouteImport
      parentRoute: typeof UseCasesRouteRoute
    }
    '/use-cases/ai-automation': {
      id: '/use-cases/ai-automation'
      path: '/ai-automation'
      fullPath: '/use-cases/ai-automation'
      preLoaderRoute: typeof UseCasesAiAutomationRouteImport
      parentRoute: typeof UseCasesRouteRoute
    }
    '/legal/terms': {
      id: '/legal/terms'
      path: '/terms'
      fullPath: '/legal/terms'
      preLoaderRoute: typeof LegalTermsRouteImport
      parentRoute: typeof LegalRouteRoute
    }
    '/legal/security': {
      id: '/legal/security'
      path: '/security'
      fullPath: '/legal/security'
      preLoaderRoute: typeof LegalSecurityRouteImport
      parentRoute: typeof LegalRouteRoute
    }
    '/legal/privacy': {
      id: '/legal/privacy'
      path: '/privacy'
      fullPath: '/legal/privacy'
      preLoaderRoute: typeof LegalPrivacyRouteImport
      parentRoute: typeof LegalRouteRoute
    }
    '/legal/compliance': {
      id: '/legal/compliance'
      path: '/compliance'
      fullPath: '/legal/compliance'
      preLoaderRoute: typeof LegalComplianceRouteImport
      parentRoute: typeof LegalRouteRoute
    }
    '/info/pricing': {
      id: '/info/pricing'
      path: '/pricing'
      fullPath: '/info/pricing'
      preLoaderRoute: typeof InfoPricingRouteImport
      parentRoute: typeof InfoRouteRoute
    }
    '/info/contact': {
      id: '/info/contact'
      path: '/contact'
      fullPath: '/info/contact'
      preLoaderRoute: typeof InfoContactRouteImport
      parentRoute: typeof InfoRouteRoute
    }
    '/info/careers': {
      id: '/info/careers'
      path: '/careers'
      fullPath: '/info/careers'
      preLoaderRoute: typeof InfoCareersRouteImport
      parentRoute: typeof InfoRouteRoute
    }
    '/info/about': {
      id: '/info/about'
      path: '/about'
      fullPath: '/info/about'
      preLoaderRoute: typeof InfoAboutRouteImport
      parentRoute: typeof InfoRouteRoute
    }
    '/features/workflow-engine': {
      id: '/features/workflow-engine'
      path: '/workflow-engine'
      fullPath: '/features/workflow-engine'
      preLoaderRoute: typeof FeaturesWorkflowEngineRouteImport
      parentRoute: typeof FeaturesRouteRoute
    }
    '/features/sso-saml': {
      id: '/features/sso-saml'
      path: '/sso-saml'
      fullPath: '/features/sso-saml'
      preLoaderRoute: typeof FeaturesSsoSamlRouteImport
      parentRoute: typeof FeaturesRouteRoute
    }
    '/features/security': {
      id: '/features/security'
      path: '/security'
      fullPath: '/features/security'
      preLoaderRoute: typeof FeaturesSecurityRouteImport
      parentRoute: typeof FeaturesRouteRoute
    }
    '/features/integrations': {
      id: '/features/integrations'
      path: '/integrations'
      fullPath: '/features/integrations'
      preLoaderRoute: typeof FeaturesIntegrationsRouteImport
      parentRoute: typeof FeaturesRouteRoute
    }
    '/features/analytics': {
      id: '/features/analytics'
      path: '/analytics'
      fullPath: '/features/analytics'
      preLoaderRoute: typeof FeaturesAnalyticsRouteImport
      parentRoute: typeof FeaturesRouteRoute
    }
    '/features/ai-gateway': {
      id: '/features/ai-gateway'
      path: '/ai-gateway'
      fullPath: '/features/ai-gateway'
      preLoaderRoute: typeof FeaturesAiGatewayRouteImport
      parentRoute: typeof FeaturesRouteRoute
    }
    '/features/agents-platform': {
      id: '/features/agents-platform'
      path: '/agents-platform'
      fullPath: '/features/agents-platform'
      preLoaderRoute: typeof FeaturesAgentsPlatformRouteImport
      parentRoute: typeof FeaturesRouteRoute
    }
    '/concepts/zero-trust-security': {
      id: '/concepts/zero-trust-security'
      path: '/zero-trust-security'
      fullPath: '/concepts/zero-trust-security'
      preLoaderRoute: typeof ConceptsZeroTrustSecurityRouteImport
      parentRoute: typeof ConceptsRouteRoute
    }
    '/concepts/workflow-automation': {
      id: '/concepts/workflow-automation'
      path: '/workflow-automation'
      fullPath: '/concepts/workflow-automation'
      preLoaderRoute: typeof ConceptsWorkflowAutomationRouteImport
      parentRoute: typeof ConceptsRouteRoute
    }
    '/concepts/webhooks': {
      id: '/concepts/webhooks'
      path: '/webhooks'
      fullPath: '/concepts/webhooks'
      preLoaderRoute: typeof ConceptsWebhooksRouteImport
      parentRoute: typeof ConceptsRouteRoute
    }
    '/concepts/rbac-abac': {
      id: '/concepts/rbac-abac'
      path: '/rbac-abac'
      fullPath: '/concepts/rbac-abac'
      preLoaderRoute: typeof ConceptsRbacAbacRouteImport
      parentRoute: typeof ConceptsRouteRoute
    }
    '/concepts/data-integration': {
      id: '/concepts/data-integration'
      path: '/data-integration'
      fullPath: '/concepts/data-integration'
      preLoaderRoute: typeof ConceptsDataIntegrationRouteImport
      parentRoute: typeof ConceptsRouteRoute
    }
    '/concepts/api-management': {
      id: '/concepts/api-management'
      path: '/api-management'
      fullPath: '/concepts/api-management'
      preLoaderRoute: typeof ConceptsApiManagementRouteImport
      parentRoute: typeof ConceptsRouteRoute
    }
    '/concepts/api-gateway': {
      id: '/concepts/api-gateway'
      path: '/api-gateway'
      fullPath: '/concepts/api-gateway'
      preLoaderRoute: typeof ConceptsApiGatewayRouteImport
      parentRoute: typeof ConceptsRouteRoute
    }
    '/concepts/ai-agents': {
      id: '/concepts/ai-agents'
      path: '/ai-agents'
      fullPath: '/concepts/ai-agents'
      preLoaderRoute: typeof ConceptsAiAgentsRouteImport
      parentRoute: typeof ConceptsRouteRoute
    }
    '/comparisons/langfuse': {
      id: '/comparisons/langfuse'
      path: '/langfuse'
      fullPath: '/comparisons/langfuse'
      preLoaderRoute: typeof ComparisonsLangfuseRouteImport
      parentRoute: typeof ComparisonsRouteRoute
    }
    '/comparisons/langchain': {
      id: '/comparisons/langchain'
      path: '/langchain'
      fullPath: '/comparisons/langchain'
      preLoaderRoute: typeof ComparisonsLangchainRouteImport
      parentRoute: typeof ComparisonsRouteRoute
    }
    '/comparisons/kong': {
      id: '/comparisons/kong'
      path: '/kong'
      fullPath: '/comparisons/kong'
      preLoaderRoute: typeof ComparisonsKongRouteImport
      parentRoute: typeof ComparisonsRouteRoute
    }
    '/comparisons/aws-api-gateway': {
      id: '/comparisons/aws-api-gateway'
      path: '/aws-api-gateway'
      fullPath: '/comparisons/aws-api-gateway'
      preLoaderRoute: typeof ComparisonsAwsApiGatewayRouteImport
      parentRoute: typeof ComparisonsRouteRoute
    }
    '/comparisons/apigee': {
      id: '/comparisons/apigee'
      path: '/apigee'
      fullPath: '/comparisons/apigee'
      preLoaderRoute: typeof ComparisonsApigeeRouteImport
      parentRoute: typeof ComparisonsRouteRoute
    }
    '/_dashboard/settings': {
      id: '/_dashboard/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof DashboardSettingsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/profile': {
      id: '/_dashboard/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof DashboardProfileRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/overview': {
      id: '/_dashboard/overview'
      path: '/overview'
      fullPath: '/overview'
      preLoaderRoute: typeof DashboardOverviewRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/api-keys': {
      id: '/_dashboard/api-keys'
      path: '/api-keys'
      fullPath: '/api-keys'
      preLoaderRoute: typeof DashboardApiKeysRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/analytics': {
      id: '/_dashboard/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof DashboardAnalyticsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/callback': {
      id: '/_auth/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_dashboard/admin': {
      id: '/_dashboard/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof DashboardAdminRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/tools/': {
      id: '/_dashboard/tools/'
      path: '/tools'
      fullPath: '/tools'
      preLoaderRoute: typeof DashboardToolsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/marketplace/': {
      id: '/_dashboard/marketplace/'
      path: '/marketplace'
      fullPath: '/marketplace'
      preLoaderRoute: typeof DashboardMarketplaceIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/integrations/': {
      id: '/_dashboard/integrations/'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof DashboardIntegrationsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/environments/': {
      id: '/_dashboard/environments/'
      path: '/environments'
      fullPath: '/environments'
      preLoaderRoute: typeof DashboardEnvironmentsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/docs/': {
      id: '/_dashboard/docs/'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof DashboardDocsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/data/': {
      id: '/_dashboard/data/'
      path: '/data'
      fullPath: '/data'
      preLoaderRoute: typeof DashboardDataIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/crews/': {
      id: '/_dashboard/crews/'
      path: '/crews'
      fullPath: '/crews'
      preLoaderRoute: typeof DashboardCrewsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/connectors/': {
      id: '/_dashboard/connectors/'
      path: '/connectors'
      fullPath: '/connectors'
      preLoaderRoute: typeof DashboardConnectorsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/agents/': {
      id: '/_dashboard/agents/'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof DashboardAgentsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/admin/': {
      id: '/_dashboard/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof DashboardAdminIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/_dashboard/tools/builder': {
      id: '/_dashboard/tools/builder'
      path: '/tools/builder'
      fullPath: '/tools/builder'
      preLoaderRoute: typeof DashboardToolsBuilderRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/tools/$id': {
      id: '/_dashboard/tools/$id'
      path: '/tools/$id'
      fullPath: '/tools/$id'
      preLoaderRoute: typeof DashboardToolsIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/marketplace/my-installs': {
      id: '/_dashboard/marketplace/my-installs'
      path: '/marketplace/my-installs'
      fullPath: '/marketplace/my-installs'
      preLoaderRoute: typeof DashboardMarketplaceMyInstallsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/marketplace/$slug': {
      id: '/_dashboard/marketplace/$slug'
      path: '/marketplace/$slug'
      fullPath: '/marketplace/$slug'
      preLoaderRoute: typeof DashboardMarketplaceSlugRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/integrations/callback': {
      id: '/_dashboard/integrations/callback'
      path: '/integrations/callback'
      fullPath: '/integrations/callback'
      preLoaderRoute: typeof DashboardIntegrationsCallbackRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/integrations/add': {
      id: '/_dashboard/integrations/add'
      path: '/integrations/add'
      fullPath: '/integrations/add'
      preLoaderRoute: typeof DashboardIntegrationsAddRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/integrations/$provider': {
      id: '/_dashboard/integrations/$provider'
      path: '/integrations/$provider'
      fullPath: '/integrations/$provider'
      preLoaderRoute: typeof DashboardIntegrationsProviderRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/environments/$id': {
      id: '/_dashboard/environments/$id'
      path: '/environments/$id'
      fullPath: '/environments/$id'
      preLoaderRoute: typeof DashboardEnvironmentsIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/docs/$': {
      id: '/_dashboard/docs/$'
      path: '/docs/$'
      fullPath: '/docs/$'
      preLoaderRoute: typeof DashboardDocsSplatRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/data/$alias': {
      id: '/_dashboard/data/$alias'
      path: '/data/$alias'
      fullPath: '/data/$alias'
      preLoaderRoute: typeof DashboardDataAliasRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/data/$': {
      id: '/_dashboard/data/$'
      path: '/data/$'
      fullPath: '/data/$'
      preLoaderRoute: typeof DashboardDataSplatRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/crews/create': {
      id: '/_dashboard/crews/create'
      path: '/crews/create'
      fullPath: '/crews/create'
      preLoaderRoute: typeof DashboardCrewsCreateRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/connectors/new': {
      id: '/_dashboard/connectors/new'
      path: '/connectors/new'
      fullPath: '/connectors/new'
      preLoaderRoute: typeof DashboardConnectorsNewRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/connectors/$connectorId': {
      id: '/_dashboard/connectors/$connectorId'
      path: '/connectors/$connectorId'
      fullPath: '/connectors/$connectorId'
      preLoaderRoute: typeof DashboardConnectorsConnectorIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/admin/audit': {
      id: '/_dashboard/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof DashboardAdminAuditRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/_dashboard/agents/create': {
      id: '/_dashboard/agents/create'
      path: '/agents/create'
      fullPath: '/agents/create'
      preLoaderRoute: typeof DashboardAgentsCreateRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/agents/create/': {
      id: '/_dashboard/agents/create/'
      path: '/'
      fullPath: '/agents/create/'
      preLoaderRoute: typeof DashboardAgentsCreateIndexRouteImport
      parentRoute: typeof DashboardAgentsCreateRouteRoute
    }
    '/_dashboard/agents/$id/': {
      id: '/_dashboard/agents/$id/'
      path: '/agents/$id'
      fullPath: '/agents/$id'
      preLoaderRoute: typeof DashboardAgentsIdIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/admin/superadmin/': {
      id: '/_dashboard/admin/superadmin/'
      path: '/superadmin'
      fullPath: '/admin/superadmin'
      preLoaderRoute: typeof DashboardAdminSuperadminIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/_dashboard/admin/org/': {
      id: '/_dashboard/admin/org/'
      path: '/org'
      fullPath: '/admin/org'
      preLoaderRoute: typeof DashboardAdminOrgIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/_dashboard/agents/create/json': {
      id: '/_dashboard/agents/create/json'
      path: '/json'
      fullPath: '/agents/create/json'
      preLoaderRoute: typeof DashboardAgentsCreateJsonRouteImport
      parentRoute: typeof DashboardAgentsCreateRouteRoute
    }
    '/_dashboard/agents/create/form': {
      id: '/_dashboard/agents/create/form'
      path: '/form'
      fullPath: '/agents/create/form'
      preLoaderRoute: typeof DashboardAgentsCreateFormRouteImport
      parentRoute: typeof DashboardAgentsCreateRouteRoute
    }
    '/_dashboard/agents/create/canvas': {
      id: '/_dashboard/agents/create/canvas'
      path: '/canvas'
      fullPath: '/agents/create/canvas'
      preLoaderRoute: typeof DashboardAgentsCreateCanvasRouteImport
      parentRoute: typeof DashboardAgentsCreateRouteRoute
    }
    '/_dashboard/agents/create/ai': {
      id: '/_dashboard/agents/create/ai'
      path: '/ai'
      fullPath: '/agents/create/ai'
      preLoaderRoute: typeof DashboardAgentsCreateAiRouteImport
      parentRoute: typeof DashboardAgentsCreateRouteRoute
    }
    '/_dashboard/agents/$id/chat': {
      id: '/_dashboard/agents/$id/chat'
      path: '/agents/$id/chat'
      fullPath: '/agents/$id/chat'
      preLoaderRoute: typeof DashboardAgentsIdChatRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/admin/superadmin/users': {
      id: '/_dashboard/admin/superadmin/users'
      path: '/superadmin/users'
      fullPath: '/admin/superadmin/users'
      preLoaderRoute: typeof DashboardAdminSuperadminUsersRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/_dashboard/admin/superadmin/system': {
      id: '/_dashboard/admin/superadmin/system'
      path: '/superadmin/system'
      fullPath: '/admin/superadmin/system'
      preLoaderRoute: typeof DashboardAdminSuperadminSystemRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/_dashboard/admin/superadmin/organizations': {
      id: '/_dashboard/admin/superadmin/organizations'
      path: '/superadmin/organizations'
      fullPath: '/admin/superadmin/organizations'
      preLoaderRoute: typeof DashboardAdminSuperadminOrganizationsRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/_dashboard/admin/org/users': {
      id: '/_dashboard/admin/org/users'
      path: '/org/users'
      fullPath: '/admin/org/users'
      preLoaderRoute: typeof DashboardAdminOrgUsersRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/_dashboard/admin/org/sso': {
      id: '/_dashboard/admin/org/sso'
      path: '/org/sso'
      fullPath: '/admin/org/sso'
      preLoaderRoute: typeof DashboardAdminOrgSsoRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/_dashboard/admin/org/security': {
      id: '/_dashboard/admin/org/security'
      path: '/org/security'
      fullPath: '/admin/org/security'
      preLoaderRoute: typeof DashboardAdminOrgSecurityRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/_dashboard/admin/org/sdk-keys': {
      id: '/_dashboard/admin/org/sdk-keys'
      path: '/org/sdk-keys'
      fullPath: '/admin/org/sdk-keys'
      preLoaderRoute: typeof DashboardAdminOrgSdkKeysRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/_dashboard/admin/org/scim': {
      id: '/_dashboard/admin/org/scim'
      path: '/org/scim'
      fullPath: '/admin/org/scim'
      preLoaderRoute: typeof DashboardAdminOrgScimRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/_dashboard/admin/org/roles': {
      id: '/_dashboard/admin/org/roles'
      path: '/org/roles'
      fullPath: '/admin/org/roles'
      preLoaderRoute: typeof DashboardAdminOrgRolesRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/_dashboard/admin/org/policies': {
      id: '/_dashboard/admin/org/policies'
      path: '/org/policies'
      fullPath: '/admin/org/policies'
      preLoaderRoute: typeof DashboardAdminOrgPoliciesRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/_dashboard/admin/org/api-keys': {
      id: '/_dashboard/admin/org/api-keys'
      path: '/org/api-keys'
      fullPath: '/admin/org/api-keys'
      preLoaderRoute: typeof DashboardAdminOrgApiKeysRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/_dashboard/admin/data/redis': {
      id: '/_dashboard/admin/data/redis'
      path: '/data/redis'
      fullPath: '/admin/data/redis'
      preLoaderRoute: typeof DashboardAdminDataRedisRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/_dashboard/admin/data/postgres': {
      id: '/_dashboard/admin/data/postgres'
      path: '/data/postgres'
      fullPath: '/admin/data/postgres'
      preLoaderRoute: typeof DashboardAdminDataPostgresRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/_dashboard/admin/data/clickhouse': {
      id: '/_dashboard/admin/data/clickhouse'
      path: '/data/clickhouse'
      fullPath: '/admin/data/clickhouse'
      preLoaderRoute: typeof DashboardAdminDataClickhouseRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
  }
}

interface AuthRouteRouteChildren {
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthCallbackRoute: AuthCallbackRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface DashboardAdminRouteRouteChildren {
  DashboardAdminAuditRoute: typeof DashboardAdminAuditRoute
  DashboardAdminIndexRoute: typeof DashboardAdminIndexRoute
  DashboardAdminDataClickhouseRoute: typeof DashboardAdminDataClickhouseRoute
  DashboardAdminDataPostgresRoute: typeof DashboardAdminDataPostgresRoute
  DashboardAdminDataRedisRoute: typeof DashboardAdminDataRedisRoute
  DashboardAdminOrgApiKeysRoute: typeof DashboardAdminOrgApiKeysRoute
  DashboardAdminOrgPoliciesRoute: typeof DashboardAdminOrgPoliciesRoute
  DashboardAdminOrgRolesRoute: typeof DashboardAdminOrgRolesRoute
  DashboardAdminOrgScimRoute: typeof DashboardAdminOrgScimRoute
  DashboardAdminOrgSdkKeysRoute: typeof DashboardAdminOrgSdkKeysRoute
  DashboardAdminOrgSecurityRoute: typeof DashboardAdminOrgSecurityRoute
  DashboardAdminOrgSsoRoute: typeof DashboardAdminOrgSsoRoute
  DashboardAdminOrgUsersRoute: typeof DashboardAdminOrgUsersRoute
  DashboardAdminSuperadminOrganizationsRoute: typeof DashboardAdminSuperadminOrganizationsRoute
  DashboardAdminSuperadminSystemRoute: typeof DashboardAdminSuperadminSystemRoute
  DashboardAdminSuperadminUsersRoute: typeof DashboardAdminSuperadminUsersRoute
  DashboardAdminOrgIndexRoute: typeof DashboardAdminOrgIndexRoute
  DashboardAdminSuperadminIndexRoute: typeof DashboardAdminSuperadminIndexRoute
}

const DashboardAdminRouteRouteChildren: DashboardAdminRouteRouteChildren = {
  DashboardAdminAuditRoute: DashboardAdminAuditRoute,
  DashboardAdminIndexRoute: DashboardAdminIndexRoute,
  DashboardAdminDataClickhouseRoute: DashboardAdminDataClickhouseRoute,
  DashboardAdminDataPostgresRoute: DashboardAdminDataPostgresRoute,
  DashboardAdminDataRedisRoute: DashboardAdminDataRedisRoute,
  DashboardAdminOrgApiKeysRoute: DashboardAdminOrgApiKeysRoute,
  DashboardAdminOrgPoliciesRoute: DashboardAdminOrgPoliciesRoute,
  DashboardAdminOrgRolesRoute: DashboardAdminOrgRolesRoute,
  DashboardAdminOrgScimRoute: DashboardAdminOrgScimRoute,
  DashboardAdminOrgSdkKeysRoute: DashboardAdminOrgSdkKeysRoute,
  DashboardAdminOrgSecurityRoute: DashboardAdminOrgSecurityRoute,
  DashboardAdminOrgSsoRoute: DashboardAdminOrgSsoRoute,
  DashboardAdminOrgUsersRoute: DashboardAdminOrgUsersRoute,
  DashboardAdminSuperadminOrganizationsRoute:
    DashboardAdminSuperadminOrganizationsRoute,
  DashboardAdminSuperadminSystemRoute: DashboardAdminSuperadminSystemRoute,
  DashboardAdminSuperadminUsersRoute: DashboardAdminSuperadminUsersRoute,
  DashboardAdminOrgIndexRoute: DashboardAdminOrgIndexRoute,
  DashboardAdminSuperadminIndexRoute: DashboardAdminSuperadminIndexRoute,
}

const DashboardAdminRouteRouteWithChildren =
  DashboardAdminRouteRoute._addFileChildren(DashboardAdminRouteRouteChildren)

interface DashboardAgentsCreateRouteRouteChildren {
  DashboardAgentsCreateAiRoute: typeof DashboardAgentsCreateAiRoute
  DashboardAgentsCreateCanvasRoute: typeof DashboardAgentsCreateCanvasRoute
  DashboardAgentsCreateFormRoute: typeof DashboardAgentsCreateFormRoute
  DashboardAgentsCreateJsonRoute: typeof DashboardAgentsCreateJsonRoute
  DashboardAgentsCreateIndexRoute: typeof DashboardAgentsCreateIndexRoute
}

const DashboardAgentsCreateRouteRouteChildren: DashboardAgentsCreateRouteRouteChildren =
  {
    DashboardAgentsCreateAiRoute: DashboardAgentsCreateAiRoute,
    DashboardAgentsCreateCanvasRoute: DashboardAgentsCreateCanvasRoute,
    DashboardAgentsCreateFormRoute: DashboardAgentsCreateFormRoute,
    DashboardAgentsCreateJsonRoute: DashboardAgentsCreateJsonRoute,
    DashboardAgentsCreateIndexRoute: DashboardAgentsCreateIndexRoute,
  }

const DashboardAgentsCreateRouteRouteWithChildren =
  DashboardAgentsCreateRouteRoute._addFileChildren(
    DashboardAgentsCreateRouteRouteChildren,
  )

interface DashboardRouteRouteChildren {
  DashboardAdminRouteRoute: typeof DashboardAdminRouteRouteWithChildren
  DashboardAnalyticsRoute: typeof DashboardAnalyticsRoute
  DashboardApiKeysRoute: typeof DashboardApiKeysRoute
  DashboardOverviewRoute: typeof DashboardOverviewRoute
  DashboardProfileRoute: typeof DashboardProfileRoute
  DashboardSettingsRoute: typeof DashboardSettingsRoute
  DashboardAgentsCreateRouteRoute: typeof DashboardAgentsCreateRouteRouteWithChildren
  DashboardConnectorsConnectorIdRoute: typeof DashboardConnectorsConnectorIdRoute
  DashboardConnectorsNewRoute: typeof DashboardConnectorsNewRoute
  DashboardCrewsCreateRoute: typeof DashboardCrewsCreateRoute
  DashboardDataSplatRoute: typeof DashboardDataSplatRoute
  DashboardDataAliasRoute: typeof DashboardDataAliasRoute
  DashboardDocsSplatRoute: typeof DashboardDocsSplatRoute
  DashboardEnvironmentsIdRoute: typeof DashboardEnvironmentsIdRoute
  DashboardIntegrationsProviderRoute: typeof DashboardIntegrationsProviderRoute
  DashboardIntegrationsAddRoute: typeof DashboardIntegrationsAddRoute
  DashboardIntegrationsCallbackRoute: typeof DashboardIntegrationsCallbackRoute
  DashboardMarketplaceSlugRoute: typeof DashboardMarketplaceSlugRoute
  DashboardMarketplaceMyInstallsRoute: typeof DashboardMarketplaceMyInstallsRoute
  DashboardToolsIdRoute: typeof DashboardToolsIdRoute
  DashboardToolsBuilderRoute: typeof DashboardToolsBuilderRoute
  DashboardAgentsIndexRoute: typeof DashboardAgentsIndexRoute
  DashboardConnectorsIndexRoute: typeof DashboardConnectorsIndexRoute
  DashboardCrewsIndexRoute: typeof DashboardCrewsIndexRoute
  DashboardDataIndexRoute: typeof DashboardDataIndexRoute
  DashboardDocsIndexRoute: typeof DashboardDocsIndexRoute
  DashboardEnvironmentsIndexRoute: typeof DashboardEnvironmentsIndexRoute
  DashboardIntegrationsIndexRoute: typeof DashboardIntegrationsIndexRoute
  DashboardMarketplaceIndexRoute: typeof DashboardMarketplaceIndexRoute
  DashboardToolsIndexRoute: typeof DashboardToolsIndexRoute
  DashboardAgentsIdChatRoute: typeof DashboardAgentsIdChatRoute
  DashboardAgentsIdIndexRoute: typeof DashboardAgentsIdIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardAdminRouteRoute: DashboardAdminRouteRouteWithChildren,
  DashboardAnalyticsRoute: DashboardAnalyticsRoute,
  DashboardApiKeysRoute: DashboardApiKeysRoute,
  DashboardOverviewRoute: DashboardOverviewRoute,
  DashboardProfileRoute: DashboardProfileRoute,
  DashboardSettingsRoute: DashboardSettingsRoute,
  DashboardAgentsCreateRouteRoute: DashboardAgentsCreateRouteRouteWithChildren,
  DashboardConnectorsConnectorIdRoute: DashboardConnectorsConnectorIdRoute,
  DashboardConnectorsNewRoute: DashboardConnectorsNewRoute,
  DashboardCrewsCreateRoute: DashboardCrewsCreateRoute,
  DashboardDataSplatRoute: DashboardDataSplatRoute,
  DashboardDataAliasRoute: DashboardDataAliasRoute,
  DashboardDocsSplatRoute: DashboardDocsSplatRoute,
  DashboardEnvironmentsIdRoute: DashboardEnvironmentsIdRoute,
  DashboardIntegrationsProviderRoute: DashboardIntegrationsProviderRoute,
  DashboardIntegrationsAddRoute: DashboardIntegrationsAddRoute,
  DashboardIntegrationsCallbackRoute: DashboardIntegrationsCallbackRoute,
  DashboardMarketplaceSlugRoute: DashboardMarketplaceSlugRoute,
  DashboardMarketplaceMyInstallsRoute: DashboardMarketplaceMyInstallsRoute,
  DashboardToolsIdRoute: DashboardToolsIdRoute,
  DashboardToolsBuilderRoute: DashboardToolsBuilderRoute,
  DashboardAgentsIndexRoute: DashboardAgentsIndexRoute,
  DashboardConnectorsIndexRoute: DashboardConnectorsIndexRoute,
  DashboardCrewsIndexRoute: DashboardCrewsIndexRoute,
  DashboardDataIndexRoute: DashboardDataIndexRoute,
  DashboardDocsIndexRoute: DashboardDocsIndexRoute,
  DashboardEnvironmentsIndexRoute: DashboardEnvironmentsIndexRoute,
  DashboardIntegrationsIndexRoute: DashboardIntegrationsIndexRoute,
  DashboardMarketplaceIndexRoute: DashboardMarketplaceIndexRoute,
  DashboardToolsIndexRoute: DashboardToolsIndexRoute,
  DashboardAgentsIdChatRoute: DashboardAgentsIdChatRoute,
  DashboardAgentsIdIndexRoute: DashboardAgentsIdIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

interface ComparisonsRouteRouteChildren {
  ComparisonsApigeeRoute: typeof ComparisonsApigeeRoute
  ComparisonsAwsApiGatewayRoute: typeof ComparisonsAwsApiGatewayRoute
  ComparisonsKongRoute: typeof ComparisonsKongRoute
  ComparisonsLangchainRoute: typeof ComparisonsLangchainRoute
  ComparisonsLangfuseRoute: typeof ComparisonsLangfuseRoute
  ComparisonsIndexRoute: typeof ComparisonsIndexRoute
}

const ComparisonsRouteRouteChildren: ComparisonsRouteRouteChildren = {
  ComparisonsApigeeRoute: ComparisonsApigeeRoute,
  ComparisonsAwsApiGatewayRoute: ComparisonsAwsApiGatewayRoute,
  ComparisonsKongRoute: ComparisonsKongRoute,
  ComparisonsLangchainRoute: ComparisonsLangchainRoute,
  ComparisonsLangfuseRoute: ComparisonsLangfuseRoute,
  ComparisonsIndexRoute: ComparisonsIndexRoute,
}

const ComparisonsRouteRouteWithChildren =
  ComparisonsRouteRoute._addFileChildren(ComparisonsRouteRouteChildren)

interface ConceptsRouteRouteChildren {
  ConceptsAiAgentsRoute: typeof ConceptsAiAgentsRoute
  ConceptsApiGatewayRoute: typeof ConceptsApiGatewayRoute
  ConceptsApiManagementRoute: typeof ConceptsApiManagementRoute
  ConceptsDataIntegrationRoute: typeof ConceptsDataIntegrationRoute
  ConceptsRbacAbacRoute: typeof ConceptsRbacAbacRoute
  ConceptsWebhooksRoute: typeof ConceptsWebhooksRoute
  ConceptsWorkflowAutomationRoute: typeof ConceptsWorkflowAutomationRoute
  ConceptsZeroTrustSecurityRoute: typeof ConceptsZeroTrustSecurityRoute
  ConceptsIndexRoute: typeof ConceptsIndexRoute
}

const ConceptsRouteRouteChildren: ConceptsRouteRouteChildren = {
  ConceptsAiAgentsRoute: ConceptsAiAgentsRoute,
  ConceptsApiGatewayRoute: ConceptsApiGatewayRoute,
  ConceptsApiManagementRoute: ConceptsApiManagementRoute,
  ConceptsDataIntegrationRoute: ConceptsDataIntegrationRoute,
  ConceptsRbacAbacRoute: ConceptsRbacAbacRoute,
  ConceptsWebhooksRoute: ConceptsWebhooksRoute,
  ConceptsWorkflowAutomationRoute: ConceptsWorkflowAutomationRoute,
  ConceptsZeroTrustSecurityRoute: ConceptsZeroTrustSecurityRoute,
  ConceptsIndexRoute: ConceptsIndexRoute,
}

const ConceptsRouteRouteWithChildren = ConceptsRouteRoute._addFileChildren(
  ConceptsRouteRouteChildren,
)

interface FeaturesRouteRouteChildren {
  FeaturesAgentsPlatformRoute: typeof FeaturesAgentsPlatformRoute
  FeaturesAiGatewayRoute: typeof FeaturesAiGatewayRoute
  FeaturesAnalyticsRoute: typeof FeaturesAnalyticsRoute
  FeaturesIntegrationsRoute: typeof FeaturesIntegrationsRoute
  FeaturesSecurityRoute: typeof FeaturesSecurityRoute
  FeaturesSsoSamlRoute: typeof FeaturesSsoSamlRoute
  FeaturesWorkflowEngineRoute: typeof FeaturesWorkflowEngineRoute
  FeaturesIndexRoute: typeof FeaturesIndexRoute
}

const FeaturesRouteRouteChildren: FeaturesRouteRouteChildren = {
  FeaturesAgentsPlatformRoute: FeaturesAgentsPlatformRoute,
  FeaturesAiGatewayRoute: FeaturesAiGatewayRoute,
  FeaturesAnalyticsRoute: FeaturesAnalyticsRoute,
  FeaturesIntegrationsRoute: FeaturesIntegrationsRoute,
  FeaturesSecurityRoute: FeaturesSecurityRoute,
  FeaturesSsoSamlRoute: FeaturesSsoSamlRoute,
  FeaturesWorkflowEngineRoute: FeaturesWorkflowEngineRoute,
  FeaturesIndexRoute: FeaturesIndexRoute,
}

const FeaturesRouteRouteWithChildren = FeaturesRouteRoute._addFileChildren(
  FeaturesRouteRouteChildren,
)

interface InfoRouteRouteChildren {
  InfoAboutRoute: typeof InfoAboutRoute
  InfoCareersRoute: typeof InfoCareersRoute
  InfoContactRoute: typeof InfoContactRoute
  InfoPricingRoute: typeof InfoPricingRoute
}

const InfoRouteRouteChildren: InfoRouteRouteChildren = {
  InfoAboutRoute: InfoAboutRoute,
  InfoCareersRoute: InfoCareersRoute,
  InfoContactRoute: InfoContactRoute,
  InfoPricingRoute: InfoPricingRoute,
}

const InfoRouteRouteWithChildren = InfoRouteRoute._addFileChildren(
  InfoRouteRouteChildren,
)

interface LegalRouteRouteChildren {
  LegalComplianceRoute: typeof LegalComplianceRoute
  LegalPrivacyRoute: typeof LegalPrivacyRoute
  LegalSecurityRoute: typeof LegalSecurityRoute
  LegalTermsRoute: typeof LegalTermsRoute
  LegalIndexRoute: typeof LegalIndexRoute
}

const LegalRouteRouteChildren: LegalRouteRouteChildren = {
  LegalComplianceRoute: LegalComplianceRoute,
  LegalPrivacyRoute: LegalPrivacyRoute,
  LegalSecurityRoute: LegalSecurityRoute,
  LegalTermsRoute: LegalTermsRoute,
  LegalIndexRoute: LegalIndexRoute,
}

const LegalRouteRouteWithChildren = LegalRouteRoute._addFileChildren(
  LegalRouteRouteChildren,
)

interface UseCasesRouteRouteChildren {
  UseCasesAiAutomationRoute: typeof UseCasesAiAutomationRoute
  UseCasesApiManagementRoute: typeof UseCasesApiManagementRoute
  UseCasesDataSynchronizationRoute: typeof UseCasesDataSynchronizationRoute
  UseCasesEnterpriseSecurityRoute: typeof UseCasesEnterpriseSecurityRoute
  UseCasesFinopsRoute: typeof UseCasesFinopsRoute
  UseCasesIndexRoute: typeof UseCasesIndexRoute
}

const UseCasesRouteRouteChildren: UseCasesRouteRouteChildren = {
  UseCasesAiAutomationRoute: UseCasesAiAutomationRoute,
  UseCasesApiManagementRoute: UseCasesApiManagementRoute,
  UseCasesDataSynchronizationRoute: UseCasesDataSynchronizationRoute,
  UseCasesEnterpriseSecurityRoute: UseCasesEnterpriseSecurityRoute,
  UseCasesFinopsRoute: UseCasesFinopsRoute,
  UseCasesIndexRoute: UseCasesIndexRoute,
}

const UseCasesRouteRouteWithChildren = UseCasesRouteRoute._addFileChildren(
  UseCasesRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  ComparisonsRouteRoute: ComparisonsRouteRouteWithChildren,
  ConceptsRouteRoute: ConceptsRouteRouteWithChildren,
  FeaturesRouteRoute: FeaturesRouteRouteWithChildren,
  InfoRouteRoute: InfoRouteRouteWithChildren,
  LegalRouteRoute: LegalRouteRouteWithChildren,
  UseCasesRouteRoute: UseCasesRouteRouteWithChildren,
  DeviceAuthRoute: DeviceAuthRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
